import { Link } from "react-router-dom";
import { Gauge } from "lucide-react";

export const Logo = ({ light = false }) => (
  <Link to="/dashboard" className="flex items-center gap-2.5 shrink-0" data-testid="app-logo">
    <span className={`flex items-center justify-center w-9 h-9 rounded-xl ${light ? "bg-white/15" : "bg-emerald-900"}`}>
      <Gauge className="w-5 h-5 text-emerald-300" strokeWidth={2.5} />
    </span>
    <span className={`font-heading text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
      Mileage<span className={light ? "text-emerald-300" : "text-emerald-600"}>Tax</span>
    </span>
  </Link>
);
